export default {"src":"/_next/static/media/gift-card.d4ee23a6.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};